/** zh-CN catalogue `json` (W3-09; English: src/formats/json/json.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'json',
  locale: 'zh-CN',
  messages: {
    'syntax.empty': '文件为空。',
    'syntax.unexpectedEnd': '文本在第 {line} 行第 {col} 列提前结束，有内容没有闭合。',
    'syntax.unterminatedString': '第 {line} 行第 {col} 列的文本缺少结尾的双引号。',
    'syntax.unexpectedChar': '第 {line} 行第 {col} 列出现意外的“{found}”。',
    'syntax.expectedValue':
      '第 {line} 行第 {col} 列应为一个值：对象、列表、双引号中的文本、数字、true、false 或 null。',
    'syntax.expectedKey': '第 {line} 行第 {col} 列应为双引号中的名称。',
    'syntax.expectedColon': '第 {line} 行第 {col} 列的名称后应为“:”。',
    'syntax.expectedCommaOrEnd': '第 {line} 行第 {col} 列应为逗号或右括号。',
    'syntax.trailingComma': '请删除第 {line} 行第 {col} 列右括号前的逗号。',
    'syntax.badNumber': '此数字的写法不正确（第 {line} 行第 {col} 列）。',
    'syntax.leadingZero': '数字不能以 0 开头后接其他数字（第 {line} 行第 {col} 列）。',
    'syntax.badEscape': '第 {line} 行第 {col} 列的文本中有未知的反斜杠转义序列。',
    'syntax.badUnicodeEscape': '\\u 序列需要正好四位十六进制数字（第 {line} 行第 {col} 列）。',
    'syntax.controlChar': '文本中的换行和制表符必须写成 \\n 和 \\t（第 {line} 行第 {col} 列）。',
    'syntax.trailingData': '第 {line} 行第 {col} 列在数据结束后还有多余的文本。',
    'syntax.tooDeep': '数据嵌套层数过深（第 {line} 行第 {col} 列）。',
  },
};

export default catalog;
